export enum Gender {
  male = 'male',
  female = 'female',
}

export type AvatarGenderSelectorProps = {
  onChange: (gender: Gender) => void;
  gender?: Gender;
};
